import React, { ReactNode, useState } from 'react';
import classnames from 'classnames';
import MaterialModal from '@mui/material/Modal';
import * as css from './modal.module.scss';

interface CommonProps {
  onClose?: Function;
  title: ReactNode;
  subtitle?: ReactNode;
  extraClasses?: string[];
  headerClasses?: string[];
  footerClasses?: string[];
  actionButtons?: ReactNode;
}

interface Props extends CommonProps {
  isOpen: boolean;
}

const Modal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
  children,
  title,
  subtitle,
  extraClasses,
  headerClasses,
  footerClasses,
  actionButtons,
}) => {
  return (
    <MaterialModal
      open={isOpen}
      onClose={() => (onClose ? onClose() : '')}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none',
        maxHeight: '100vh',
        overflowY: 'auto',
        minHeight: 'min-content',
      }}
    >
      <div className={classnames(css.alpBaseModal, extraClasses)}>
        <div className={classnames(css.alpModalHeader, headerClasses)}>
          <h2>{title}</h2>
          {subtitle ? <h3>{subtitle}</h3> : ''}
        </div>
        <div className={css.alpModalContents}>{children}</div>
        {actionButtons && (
          <div className={classnames(css.alpModalFooter, footerClasses)}>
            {actionButtons}
          </div>
        )}
      </div>
    </MaterialModal>
  );
};

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const LocalModal: React.FC<React.PropsWithChildren<CommonProps>> = ({
    children,
    ...props
  }) => {
    const onClose = () => {
      if (typeof props.onClose == 'function') {
        props.onClose();
      }
      close();
    };

    if (isOpen) {
      return (
        <Modal isOpen={isOpen} onClose={onClose} {...props}>
          {children}
        </Modal>
      );
    }

    return <></>;
  };

  return { isOpen, open, close, Modal: LocalModal };
};

export default Modal;
